<template>
  <div class="raw-materials-container" ref="containerRef">
    <div class="input-area" :class="{ editing: isEditing }">
      <div class="input-row">
        <div class="input-group">
          <label class="input-label">原辅材料类型</label>
          <select
            v-model="inputForm.type"
            class="input-select"
            :disabled="isEditing"
          >
            <option value="原材料">原材料</option>
            <option value="辅助材料">辅助材料</option>
            <option value="其他材料">其他材料</option>
          </select>
        </div>
        <template v-if="inputForm.type === '原材料'">
          <div class="input-group">
            <label class="input-label">名称</label>
            <input
              type="text"
              v-model="inputForm.name"
              class="input-field"
              placeholder="请输入名称"
            />
          </div>
          <div class="input-group">
            <label class="input-label">单位</label>
            <input
              type="text"
              v-model="inputForm.unit"
              class="input-field"
              placeholder="请输入单位"
            />
          </div>
          <div class="input-group">
            <label class="input-label">年消耗量</label>
            <input
              type="number"
              v-model.number="inputForm.quantity"
              class="input-field"
              placeholder="请输入年消耗量"
            />
          </div>
          <div class="input-group">
            <label class="input-label">单价（元）</label>
            <input
              type="number"
              v-model.number="inputForm.unitPrice"
              class="input-field"
              placeholder="请输入单价"
            />
          </div>
        </template>
        <template v-else>
          <div class="input-group">
            <label class="input-label">金额（万元）</label>
            <input
              type="number"
              v-model.number="inputForm.amount"
              class="input-field"
              placeholder="请输入金额"
            />
          </div>
        </template>
        <div class="input-group">
          <label class="input-label">进项税率(%)</label>
          <input
            type="number"
            v-model.number="inputForm.taxRate"
            class="input-field"
            placeholder="请输入进项税率"
            min="0"
            max="33"
            @blur="validateTaxRate"
          />
        </div>
        <button v-if="!isEditing" class="add-btn" @click="addMaterial">
          添加
        </button>
        <template v-else>
          <button
            class="add-btn"
            style="background-color: #67c23a"
            @click="saveEdit"
          >
            修改
          </button>
          <button
            class="add-btn"
            style="background-color: #909399"
            @click="cancelEdit"
          >
            取消
          </button>
        </template>
      </div>
    </div>
    <div class="table-wrapper">
      <div class="table-scroll-area">
        <table class="materials-table">
          <thead>
            <tr>
              <th class="seq-col">序号</th>
              <th class="item-col">项 目</th>
              <th class="total-col">合计</th>
              <th
                class="year-col"
                v-for="year in constru.calculationPeriod"
                :key="year"
              >
                {{ year }}
              </th>
            </tr>
            <tr>
              <th class="seq-col">-</th>
              <th class="item-col">建设期/运营期</th>
              <th class="total-col">-</th>

              <th
                class="year-col period-type-col"
                :colspan="constru.constructionPeriod"
              >
                建设期
              </th>
              <th
                class="year-col period-type-col"
                :colspan="constru.operationPeriod"
              >
                运营期
              </th>
            </tr>
          </thead>
          <tbody>
            <tr class="category-row">
              <td class="seq-col">1</td>
              <td class="item-col">原材料费用</td>
              <td class="total-col">
                {{ formatNumber(rawMaterialsData.materials?.total) }}
              </td>
              <td
                class="year-col"
                v-for="year in constru.calculationPeriod"
                :key="year"
              >
                {{ formatNumber(rawMaterialsData.materials?.year[year - 1]) }}
              </td>
            </tr>
            <template
              v-for="material in rawMaterialsData.materials?.materialslist ||
              []"
            >
              <tr
                :key="'name-' + material.id"
                class="detail-row"
                v-if="rawMaterialsData.materials.materialslist.length > 0"
              >
                <td class="seq-col">{{ material.sequence }}</td>
                <td class="item-col">
                  <div class="material-cell">
                    <span
                      class="material-name"
                      :data-material-id="material.id"
                      @mouseenter="showRawDropdown(material, $event)"
                      @mouseleave="startHideDropdown"
                      >{{ material.name }}（{{ material.unitPrice }}元/{{
                        material.unit || "吨"
                      }}）</span
                    >
                  </div>
                </td>
                <td class="total-col">{{ formatNumber(material.total) }}</td>
                <td
                  class="year-col"
                  v-for="(value, yearIndex) in material.year"
                  :key="'t' + yearIndex"
                >
                  <span>{{ formatNumber(value) }}</span>
                </td>
              </tr>
              <tr
                :key="'quantity-' + material.id"
                class="detail-row"
                v-if="rawMaterialsData.materials.materialslist.length > 0"
              >
                <td class="seq-col"></td>
                <td class="item-col">年耗量（{{ material.unit }}）</td>
                <td class="total-col">
                  {{ material.consumptionTotal }}
                </td>
                <td
                  class="year-col"
                  v-for="(value, index) in material.consumption || []"
                  :key="'p' + index"
                >
                  <span>{{ formatNumber(value) }}</span>
                </td>
              </tr>
              <tr
                :key="'tax-' + material.id"
                class="detail-row"
                v-if="rawMaterialsData.materials.materialslist.length > 0"
              >
                <td class="seq-col"></td>
                <td class="item-col">
                  进项税额{{ formatTaxRate(material.taxRate) }}
                </td>
                <td class="total-col">
                  {{ formatNumber(material.taxTotal) }}
                </td>
                <td
                  class="year-col"
                  v-for="(value, index) in material.tax || []"
                  :key="'s' + index"
                >
                  <span>{{ formatNumber(value) }}</span>
                </td>
              </tr>
            </template>
            <tr class="category-row">
              <td class="seq-col">2</td>
              <td class="item-col">
                <div class="material-cell">
                  <span
                    class="material-name"
                    @mouseenter="showAuxiliaryDropdown($event)"
                    @mouseleave="startHideDropdown"
                    style="font-weight: 900"
                    >辅助材料费用</span
                  >
                </div>
              </td>
              <td class="total-col">
                {{ formatNumber(rawMaterialsData.auxiliary?.total) }}
              </td>
              <td
                class="year-col"
                v-for="year in constru.calculationPeriod"
                :key="'aux-' + year"
              >
                <span>{{
                  formatNumber(rawMaterialsData.auxiliary?.year[year - 1])
                }}</span>
              </td>
            </tr>
            <tr class="detail-row">
              <td class="seq-col"></td>
              <td class="item-col">
                进项税额{{ formatTaxRate(rawMaterialsData.auxiliary?.taxRate) }}
              </td>
              <td class="total-col">
                {{ formatNumber(rawMaterialsData.auxiliary?.taxTotal) }}
              </td>
              <td
                class="year-col"
                v-for="year in constru.calculationPeriod"
                :key="'aux-tax-' + year"
              >
                <span>{{
                  formatNumber(rawMaterialsData.auxiliary?.tax[year - 1])
                }}</span>
              </td>
            </tr>
            <tr class="category-row">
              <td class="seq-col">3</td>
              <td class="item-col">
                <div class="material-cell">
                  <span
                    class="material-name"
                    @mouseenter="showOtherDropdown($event)"
                    @mouseleave="startHideDropdown"
                    style="font-weight: 900"
                    >其他材料费用</span
                  >
                </div>
              </td>
              <td class="total-col">
                {{ formatNumber(rawMaterialsData.other?.total) }}
              </td>
              <td
                class="year-col"
                v-for="year in constru.calculationPeriod"
                :key="'other-' + year"
              >
                <span>{{
                  formatNumber(rawMaterialsData.other?.year[year - 1])
                }}</span>
              </td>
            </tr>
            <tr class="detail-row">
              <td class="seq-col"></td>
              <td class="item-col">
                进项税额{{ formatTaxRate(rawMaterialsData.other?.taxRate) }}
              </td>
              <td class="total-col">
                {{ formatNumber(rawMaterialsData.other?.taxTotal) }}
              </td>
              <td
                class="year-col"
                v-for="year in constru.calculationPeriod"
                :key="'other-tax-' + year"
              >
                <span>{{
                  formatNumber(rawMaterialsData.other?.tax[year - 1])
                }}</span>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr class="summary-row">
              <td class="seq-col">4</td>
              <td class="item-col">外购原辅材料合计</td>
              <td class="total-col">
                {{ formatNumber(rawMaterialsData.total?.total) }}
              </td>
              <td
                class="year-col"
                v-for="year in constru.calculationPeriod"
                :key="'grand-' + year"
              >
                <span>{{
                  formatNumber(rawMaterialsData.total?.year[year - 1])
                }}</span>
              </td>
            </tr>
            <tr class="summary-row">
              <td class="seq-col">5</td>
              <td class="item-col">进项税额合计</td>
              <td class="total-col">
                {{ formatNumber(rawMaterialsData.total?.taxTotal) }}
              </td>
              <td
                class="year-col"
                v-for="year in constru.calculationPeriod"
                :key="'grand-tax-' + year"
              >
                <span>{{
                  formatNumber(rawMaterialsData.total?.tax[year - 1])
                }}</span>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
      <div
        v-if="rawDropdownVisible"
        class="global-dropdown"
        :style="{ top: dropdownTop + 'px', left: dropdownLeft + 'px' }"
        @mouseenter="cancelHideDropdown"
        @mouseleave="hideDropdown"
      >
        <div class="menu-item" @click="editRawMaterial">修改</div>
        <div class="menu-item danger" @click="deleteRawMaterial">删除</div>
      </div>
      <div
        v-if="auxiliaryDropdownVisible"
        class="global-dropdown"
        :style="{ top: dropdownTop + 'px', left: dropdownLeft + 'px' }"
        @mouseenter="cancelHideDropdown"
        @mouseleave="hideDropdown"
      >
        <div class="menu-item" @click="editAuxiliaryMaterial">修改</div>
        <!-- 辅助材料不可删除 -->
      </div>
      <div
        v-if="otherDropdownVisible"
        class="global-dropdown"
        :style="{ top: dropdownTop + 'px', left: dropdownLeft + 'px' }"
        @mouseenter="cancelHideDropdown"
        @mouseleave="hideDropdown"
      >
        <div class="menu-item" @click="editOtherMaterial">修改</div>
        <!-- 其他材料不可删除 -->
      </div>
    </div>
  </div>
</template>

<script>
import { jingying } from "@/utils/comp.js";

export default {
  name: "RawMaterials",
  data() {
    return {
      inputForm: {
        type: "原材料",
        name: "",
        unit: "",
        quantity: 0,
        unitPrice: 0,
        amount: 0,
        taxRate: 17,
      },
      isEditing: false,
      currentEditId: null,
      editingType: null,
      rawDropdownVisible: false,
      auxiliaryDropdownVisible: false,
      otherDropdownVisible: false,
      dropdownTop: 0,
      dropdownLeft: 0,
      currentRawMaterial: null,
      hideTimeout: null,

      projectData: {},
      rawMaterialsData: {},
    };
  },
  computed: {
    // 改为计算属性，确保实时获取最新基础数据
    constru() {
      return this.projectData["基础数据"] || {};
    }
  },
  watch: {
    // 监听原辅材料数据变化
    "$store.state.projectData.成本费用.原辅材料": {
      handler() {
        this.loadFromVuex();
      },
      deep: true,
    },
  },
  created() {
    this.loadFromVuex();
    document.addEventListener("visibilitychange", this.handleVisibilityChange);
  },
  beforeDestroy() {
    document.removeEventListener(
      "visibilitychange",
      this.handleVisibilityChange
    );
  },
  methods: {
    handleVisibilityChange() {
      if (!document.hidden) {
        this.loadFromVuex();
      }
    },
    formatNumber(num) {
      if (num === null || num === undefined || isNaN(num)) return "";
      if (num === 0) return "";
      return Number(num)
        .toFixed(2)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    formatTaxRate(taxRate) {
      if (!taxRate || isNaN(taxRate)) {
        return "(0%)";
      }
      return `(${Math.round(taxRate * 100)}%)`;
    },
    validateTaxRate() {
      if (this.inputForm.taxRate > 33) {
        this.inputForm.taxRate = 33;
      }
      if (this.inputForm.taxRate < 0) {
        this.inputForm.taxRate = 0;
      }
    },
    calculateDropdownPosition(event) {
      const rect = event.target.getBoundingClientRect();
      const containerRect = this.$refs.containerRef.getBoundingClientRect();
      return {
        top: rect.bottom,
        left: rect.left,
      };
    },
    showRawDropdown(material, event) {
      if (this.hideTimeout) {
        clearTimeout(this.hideTimeout);
        this.hideTimeout = null;
      }
      this.hideAllDropdowns();
      this.currentRawMaterial = material;
      const pos = this.calculateDropdownPosition(event);
      this.dropdownTop = pos.top;
      this.dropdownLeft = pos.left;
      this.rawDropdownVisible = true;
    },
    showAuxiliaryDropdown(event) {
      if (this.hideTimeout) {
        clearTimeout(this.hideTimeout);
        this.hideTimeout = null;
      }
      this.hideAllDropdowns();
      const pos = this.calculateDropdownPosition(event);
      this.dropdownTop = pos.top;
      this.dropdownLeft = pos.left;
      this.auxiliaryDropdownVisible = true;
    },
    showOtherDropdown(event) {
      if (this.hideTimeout) {
        clearTimeout(this.hideTimeout);
        this.hideTimeout = null;
      }
      this.hideAllDropdowns();
      const pos = this.calculateDropdownPosition(event);
      this.dropdownTop = pos.top;
      this.dropdownLeft = pos.left;
      this.otherDropdownVisible = true;
    },
    hideAllDropdowns() {
      this.rawDropdownVisible = false;
      this.auxiliaryDropdownVisible = false;
      this.otherDropdownVisible = false;
    },
    startHideDropdown() {
      if (this.hideTimeout) {
        clearTimeout(this.hideTimeout);
      }
      this.hideTimeout = setTimeout(() => {
        this.hideAllDropdowns();
      }, 100);
    },
    cancelHideDropdown() {
      if (this.hideTimeout) {
        clearTimeout(this.hideTimeout);
        this.hideTimeout = null;
      }
    },
    hideDropdown() {
      if (this.hideTimeout) {
        clearTimeout(this.hideTimeout);
        this.hideTimeout = null;
      }
      this.hideAllDropdowns();
    },
    // 修改原材料
    editRawMaterial() {
      if (this.currentRawMaterial) {
        this.isEditing = true;
        this.editingType = "raw";
        this.currentEditId = this.currentRawMaterial.id;
        this.inputForm = {
          type: "原材料",
          name: this.currentRawMaterial.name,
          unit: this.currentRawMaterial.unit,
          quantity: this.currentRawMaterial.quantity,
          unitPrice: this.currentRawMaterial.unitPrice,
          taxRate: this.currentRawMaterial.taxRate * 100,
        };
      }
    },
    // 修改辅助材料
    editAuxiliaryMaterial() {
      this.isEditing = true;
      this.editingType = "auxiliary";
      this.inputForm = {
        type: "辅助材料",
        name: "辅助材料费用",
        amount: this.rawMaterialsData.auxiliary.Amount || 0,
        taxRate: this.rawMaterialsData.auxiliary.taxRate * 100,
      };
    },
    // 修改其他材料
    editOtherMaterial() {
      this.isEditing = true;
      this.editingType = "other";
      this.inputForm = {
        type: "其他材料",
        name: "其他材料费用",
        amount: this.rawMaterialsData.other.Amount || 0,
        taxRate: this.rawMaterialsData.other.taxRate * 100,
      };
    },
    // 删除原材料
    deleteRawMaterial() {
      if (!this.currentRawMaterial) return;

      this.$confirm("确定要删除该材料吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const index = this.rawMaterialsData.materials.materialslist.findIndex(
            (m) => m.id === this.currentRawMaterial.id
          );
          if (index !== -1) {
            this.rawMaterialsData.materials.materialslist.splice(index, 1);
            // 更新序号
            this.rawMaterialsData.materials.materialslist.forEach(
              (material, i) => {
                material.sequence = `1.${i + 1}`;
              }
            );
            this.updateStore();
            setTimeout(() => {
              jingying();
            }, 100);
          }
        })
        .catch(() => {});
    },
    // 添加材料
    addMaterial() {
      if (
        this.inputForm.type === "原材料" &&
        (!this.inputForm.name || !this.inputForm.name.toString().trim())
      ) {
        this.$toast.warning("请输入名称");
        return;
      }

      if (this.inputForm.type === "原材料") {
        if (!this.inputForm.unit) {
          this.$toast.warning("请输入单位");
          return;
        }
        if (!this.inputForm.quantity) {
          this.$toast.warning("请输入数量");
          return;
        }
        if (!this.inputForm.unitPrice) {
          this.$toast.warning("请输入单价");
          return;
        }

        const taxRate = (this.inputForm.taxRate || 17) / 100;

        const material = {
          id: Date.now(),
          name: this.inputForm.name,
          unit: this.inputForm.unit,
          quantity: this.inputForm.quantity,
          unitPrice: this.inputForm.unitPrice,
          sequence: `1.${
            this.rawMaterialsData.materials.materialslist.length + 1
          }`,
          taxRate: taxRate,
          total: 0,
          taxTotal: 0,
          consumptionTotal: 0,
          year: [],
          tax: [],
          consumption: [],
        };
        this.rawMaterialsData.materials.materialslist.push(material);
      } else if (this.inputForm.type === "辅助材料") {
        this.rawMaterialsData.auxiliary.Amount = this.inputForm.amount || 0;
        this.rawMaterialsData.auxiliary.taxRate =
          (this.inputForm.taxRate || 17) / 100;
      } else if (this.inputForm.type === "其他材料") {
        this.rawMaterialsData.other.Amount = this.inputForm.amount || 0;
        this.rawMaterialsData.other.taxRate =
          (this.inputForm.taxRate || 17) / 100;
      }

      this.updateStore();
      setTimeout(() => {
        jingying();
      }, 100);
      this.resetForm();
    },
    // 保存修改
    saveEdit() {
      if (this.editingType === "raw") {
        if (!this.inputForm.name.trim()) {
          this.$toast.warning("请输入名称");
          return;
        }

        const index = this.rawMaterialsData.materials.materialslist.findIndex(
          (m) => m.id === this.currentEditId
        );
        if (index !== -1) {
          const quantity = this.inputForm.quantity || 0;
          const unitPrice = this.inputForm.unitPrice || 0;
          const taxRate = (this.inputForm.taxRate || 17) / 100;

          this.rawMaterialsData.materials.materialslist[index].name =
            this.inputForm.name;
          this.rawMaterialsData.materials.materialslist[index].unit =
            this.inputForm.unit;
          this.rawMaterialsData.materials.materialslist[index].quantity =
            quantity;
          this.rawMaterialsData.materials.materialslist[index].unitPrice =
            unitPrice;
          this.rawMaterialsData.materials.materialslist[index].taxRate =
            taxRate;
        }
      } else if (this.editingType === "auxiliary") {
        this.rawMaterialsData.auxiliary.Amount = this.inputForm.amount || 0;
        this.rawMaterialsData.auxiliary.taxRate =
          (this.inputForm.taxRate || 17) / 100;
      } else if (this.editingType === "other") {
        this.rawMaterialsData.other.Amount = this.inputForm.amount || 0;
        this.rawMaterialsData.other.taxRate =
          (this.inputForm.taxRate || 17) / 100;
      }

      this.updateStore();
      setTimeout(() => {
        jingying();
      }, 100);
      this.cancelEdit();
    },
    // 取消编辑
    cancelEdit() {
      this.isEditing = false;
      this.currentEditId = null;
      this.editingType = null;
      this.resetForm();
    },
    // 重置表单
    resetForm() {
      this.inputForm = {
        type: "原材料",
        name: "",
        unit: "",
        quantity: 0,
        unitPrice: 0,
        amount: 0,
        taxRate: 17,
      };
    },
    // 更新store
    updateStore() {
      this.projectData["成本费用"]["原辅材料"] = this.rawMaterialsData;
      this.$store.commit("SET_PROJECT_DATA", this.projectData);
    },
    // 从store加载数据
    loadFromVuex() {
      this.projectData = this.$store.state.projectData || {};
      // jingying();
      this.rawMaterialsData = (this.projectData["成本费用"] &&
        this.projectData["成本费用"]["原辅材料"]) || {
        materials: {
          year: [],
          tax: [],
          materialslist: [],
        },
        auxiliary: {
          taxRate: 0.17,
          Amount: 0,
          year: [],
          tax: [],
        },
        other: {
          taxRate: 0.17,
          Amount: 0,
          year: [],
          tax: [],
        },
        total: {
          year: [],
          tax: [],
        },
      };

    },
  },
};
</script>

<style scoped>
/* 保留原有样式 */
.input-area {
  display: flex;
  align-items: flex-start;
  gap: 15px;
  padding: 15px 20px;
  background-color: white;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  margin-bottom: 10px;
  flex-wrap: wrap;
  flex-shrink: 0;
}

.input-area.editing {
  background-color: #f0f2f5;
  border-color: #409eff;
  box-shadow: 0 0 8px rgba(64, 158, 255, 0.3);
}

.input-row {
  display: flex;
  align-items: flex-start;
  gap: 15px;
  flex-wrap: wrap;
}

.input-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.input-label {
  font-size: 14px;
  color: #606266;
  white-space: nowrap;
  font-weight: 500;
}

.input-select {
  width: 100px;
  padding: 8px 12px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  font-size: 14px;
  color: #606266;
  background-color: white;
  cursor: pointer;
}

.input-select:focus {
  border-color: #409eff;
  outline: none;
}

.input-field {
  width: 110px;
  padding: 8px 12px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  font-size: 14px;
}

.input-field:focus {
  border-color: #409eff;
  outline: none;
}

.input-field[type="number"] {
  text-align: right;
}

.add-btn {
  padding: 8px 20px;
  background-color: #409eff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  margin-top: 22px;
  font-weight: 500;
}

.add-btn:hover {
  background-color: #66b1ff;
}

.table-wrapper {
  position: relative;
  width: 99.5%;
  height: calc(100vh - 280px);
  margin: auto;
  min-height: 400px;
  max-height: 600px;
  overflow: hidden;
  background-color: white;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
}

.table-scroll-area {
  width: 100%;
  height: 100%;
  overflow: auto;
  position: relative;
}

.materials-table {
  width: 100%;
  min-width: 1200px;
  border-collapse: collapse;
  table-layout: fixed;
}

.materials-table th {
  background-color: #f5f7fa;
  border: 1px solid #e4e7ed;
  padding: 8px 6px;
  text-align: center;
  font-weight: 600;
  color: #606266;
  font-size: 12px;
  white-space: nowrap;
}

.materials-table td {
  border: 1px solid #e4e7ed;
  padding: 6px 6px;
  text-align: center;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.materials-table tfoot {
  background-color: #ecf5ff;
}

.materials-table tfoot td {
  font-weight: 600;
}

.category-row {
  background-color: #f5f7fa;
}

.category-row td {
  font-weight: 600;
  color: #303133;
}

.detail-row td {
  background-color: white;
}

.detail-row td.item-col {
  text-align: left;
}

.summary-row {
  background-color: #ecf5ff;
}

.summary-row td {
  font-weight: 600;
  color: #303133;
}

.material-name {
  color: #303133;
  font-weight: 500;
  cursor: pointer;
}

.material-name:hover {
  color: #409eff;
}

.material-cell {
  position: relative;
  display: inline-block;
}

.global-dropdown {
  position: fixed;
  z-index: 10000;
  background-color: white;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  min-width: 70px;
}

.menu-item {
  padding: 10px 20px;
  font-size: 13px;
  color: #606266;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
}

.menu-item:hover {
  background-color: #409eff;
  color: white;
}

.menu-item.danger {
  color: #f56c6c;
}

.menu-item.danger:hover {
  background-color: #f56c6c;
  color: white;
}

.seq-col {
  width: 45px;
  min-width: 45px;
}

.item-col {
  width: 140px;
  min-width: 140px;
  text-align: left;
}

.total-col {
  width: 80px;
  min-width: 80px;
  font-weight: 600;
}

.year-col {
  width: 55px;
  min-width: 55px;
}

.period-type-col {
  padding: 4px 2px !important;
  font-size: 11px;
}

.construction-badge {
  display: inline-block;
  padding: 2px 6px;
  background-color: #409eff;
  color: white;
  border-radius: 3px;
  font-size: 10px;
  font-weight: 500;
}

.operation-badge {
  display: inline-block;
  padding: 2px 6px;
  background-color: #67c23a;
  color: white;
  border-radius: 3px;
  font-size: 10px;
  font-weight: 500;
}
</style>
